import { colors } from '../../partners/tokens'

export const Slider = {
  sizes: {
    lg: { thumbSize: 44, sliderTrackHeight: 13, _interactionBox: { p: 0 } },
  },
}

export const SliderTrack = {
  baseStyle: {
    bg: 'transparent',
    color: 'primary.500',
    borderColor: 'gray.600',
    borderWidth: 1,
  },
}

export const SliderFilledTrack = {
  baseStyle: ({ colorScheme }: any) => {
    return {
      bg: `${colorScheme}.700`,
    }
  },
}

export const SliderThumb = {
  baseStyle: (props: any) => {
    const { colorScheme } = props
    return {
      _light: {
        bg: 'white',
        borderWidth: 1,
        borderColor: colors.primary[500],
        backgroundColor: `${colorScheme}.100`,
        p: 0,
        _interactionBox: {
          width: 'full',
          height: 'full',
          borderRadius: 'full',
        },
        _hover: {
          shadowColor: `${colorScheme}.200`,
          outlineColor: colors.primary[200],
          shadowRadius: 4,
        },
        _focus: {
          outlineColor: colors.primary[500],
        },
        _pressed: {
          _interactionBox: {
            borderWidth: 0,
          },
        },
        _stack: {
          borderWidth: 1,
          borderColor: `${colorScheme}.`,
          width: 'full',
          height: 'full',
          borderRadius: 'full',
        },
      },
    }
  },
}
